import HttpService from './http.service';

class InvoiceService {
  getInvoices(params) {
    return HttpService.get('invoices', {
      params,
    })
      .then((res) => res.data);
  }

  getInvoice(id) {
    return HttpService.get(`invoices/${id}`)
      .then((res) => res.data);
  }

  sendInvoice(id, params) {
    return HttpService.get(`invoices/send_invoice/${id}`, {
      params,
    })
      .then((res) => res.data);
  }

  getInvoicePdf(id) {
    return HttpService.get(`invoices/pdf/${id}`)
      .then((res) => res.data);
  }

  createInvoice(invoice) {
    return HttpService.post('invoices', invoice)
      .then((res) => res.data);
  }

  updateInvoice(invoice) {
    return HttpService.patch(`invoices/${invoice.id}`, invoice)
      .then((res) => res.data);
  }

  deleteInvoice(invoice) {
    return HttpService.delete(`invoices/${invoice.id}`)
      .then((res) => res.data);
  }
}

export default new InvoiceService();
